import React, { useState } from "react";
import { useAuthController } from "./state/authStore";
import SignInPage from "./routes/SignInPage";
import SystemStatePage from "./routes/SystemStatePage";
import PnlPage from "./routes/PnlPage";

type Tab = "system" | "pnl";

export default function App() {
  const auth = useAuthController();
  const [tab, setTab] = useState<Tab>("system");

  if (auth.authState === "checking") {
    return (
      <div className="authPage">
        <div className="authCard">
          <h1>Divina</h1>
          <p className="muted">Checking session…</p>
        </div>
      </div>
    );
  }

  if (auth.authState !== "authenticated") {
    return <SignInPage auth={auth} />;
  }

  return (
    <div className="appShell">
      <header className="topbar">
        <div className="brand">Divina</div>
        <nav className="tabs">
          <button
            type="button"
            className={tab === "system" ? "tab active" : "tab"}
            aria-current={tab === "system" ? "page" : undefined}
            onClick={() => setTab("system")}
          >
            System State
          </button>
          <button
            type="button"
            className={tab === "pnl" ? "tab active" : "tab"}
            aria-current={tab === "pnl" ? "page" : undefined}
            onClick={() => setTab("pnl")}
          >
            P&amp;L
          </button>
        </nav>
        <div className="topbarRight">
          {auth.authUser?.username ? <span className="muted user">{auth.authUser.username}</span> : null}
          <button type="button" className="btn ghost" onClick={() => void auth.signOut()}>
            Sign out
          </button>
        </div>
      </header>
      <main className="content">{tab === "system" ? <SystemStatePage /> : <PnlPage />}</main>
    </div>
  );
}
